import { api } from 'utility';
import { getClientListsUrl, getWithdrawRulesUrl } from 'URLs';
export function getWithdrawRules(params) {
  return api.get(getWithdrawRulesUrl(), { params }).then((res) => res.data);
}

export function getClients(data, params) {
  return api.post(getClientListsUrl(), data, { params }).then((res) => res.data);
}

export default {
  getWithdrawRules,
  getClients,
};
